// src/pages/organization/GradingListPage.jsx
import React, { useEffect, useState } from "react";
import { httpRequest } from "../../utils/httpRequest";
import { Link } from "react-router-dom";
import Sidebar from "../../components/layout/Sidebar";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Header from "../../components/layout/Header";

export default function GradingListPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const { t, i18n } = useTranslation();

  const fetchData = async (p = 1) => {
    try {
      setLoading(true);
      const res = await httpRequest(
        "GET",
        `/attempt/grading-queue/list?page=${p}&limit=20`,
        {},
        { "x-access-token": user.token }
      );
      setRows(res?.data?.data || []);
      setTotal(res?.data?.total || 0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!user?.token) return;
    fetchData(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const pages = Math.max(1, Math.ceil(total / 20));

  const isRtl = i18n.language.includes("fa");
  const mainContentClass = `flex-1 flex flex-col px-2 pb-5 lg:px-0 lg:pb-0 ${
    isRtl ? "md:mr-64" : "md:ml-64"
  }`;
  const mainSectionClass = `flex-1 overflow-y-auto p-4 md:p-6 bg-gray-100 rounded-[16px] ${
    isRtl ? "lg:me-3 lg:mb-3" : "lg:ms-3 lg:mb-3"
  }`;

  return (
    <div className="flex h-screen">
      <Helmet>
        <title>{t("grading_list.page_title")}</title>
      </Helmet>

      <Sidebar />
      <div className={mainContentClass}>
        <Header />
        <main className={mainSectionClass}>
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-xl font-semibold">
              {t("grading_list.page_title")}
            </h1>
            <div className="text-sm text-gray-500">
              {total} {t("grading_list.attempts")}
            </div>
          </div>

          {loading ? (
            <div className="text-sm text-gray-500">
              {t("grading_list.loading")}
            </div>
          ) : rows.length === 0 ? (
            <div className="text-sm text-gray-500">
              {t("grading_list.nothing_to_grade")}
            </div>
          ) : (
            <div className="overflow-x-auto rounded-lg border bg-white">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 ">
                      {t("grading_list.exam")}
                    </th>
                    <th className="px-3 py-2 ">
                      {t("grading_list.candidate")}
                    </th>
                    <th className="px-3 py-2 ">
                      {t("grading_list.submitted")}
                    </th>
                    <th className="px-3 py-2 ">
                      {t("grading_list.needs_review")}
                    </th>
                    <th className="px-3 py-2 ">
                      {t("grading_list.score_breakdown")}
                    </th>
                    <th className="px-3 py-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.attemptId} className="border-t">
                      {console.log(r)}
                      <td className="px-3 py-2">{r.examTitle}</td>
                      <td className="px-3 py-2">{r.userName}</td>
                      <td className="px-3 py-2 text-left">
                        {r.submittedAt
                          ? new Date(r.submittedAt).toLocaleString()
                          : t("common.placeholder")}
                      </td>
                      <td className="px-3 py-2 ">
                        {r.needsReviewCount}
                      </td>
                      <td className="px-3 py-2 ">
                        {r.totalAuto} / {r.totalManual} /{" "}
                        <span className="font-medium">{r.totalScore}</span>
                      </td>
                      <td className="px-3 py-2 ">
                        <Link
                          to={`/organization/grading/${r.attemptId}`}
                          className="inline-flex items-center px-3 py-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700"
                        >
                          {t("grading_list.grade_button")}
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {pages > 1 && (
            <div className="mt-4 flex items-center justify-center gap-2">
              <button
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page <= 1}
                className={`px-3 py-1 rounded border ${
                  page <= 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-white"
                }`}
              >
                {t("common.previous")}
              </button>
              <div className="text-sm">
                {page} / {pages}
              </div>
              <button
                onClick={() => setPage((p) => Math.min(pages, p + 1))}
                disabled={page >= pages}
                className={`px-3 py-1 rounded border ${
                  page >= pages
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-white"
                }`}
              >
                {t("common.next")}
              </button>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
